import { AgentNetDoc, Block } from '@fluentsms/agentnet-web-icons';
import { useTheme } from '@material-ui/core';
import React from 'react';

interface ReadOnlyProps {
  customIcon?: 'Block' | 'Template';
}

export const ReadOnly = (props: ReadOnlyProps): JSX.Element => {
  const { customIcon } = props;
  const theme = useTheme();

  return customIcon === 'Template' ? (
    <AgentNetDoc
      data-testid="custom-template-block-read-only-icon"
      height="auto"
      width="16"
      fill={theme.palette.secondary.main}
    />
  ) : (
    <Block
      data-testid="custom-template-block-read-only-icon"
      height="auto"
      width="16"
      fill={theme.palette.secondary.main}
    />
  );
};
